var map = {
	"./__tests__/questionnaires.test.js": [
		1369,
		782
	],
	"./act.js": [
		2623,
		411
	],
	"./cat.js": [
		3879,
		791
	],
	"./r-scale.js": [
		3874,
		870
	],
	"./respHealthAssessment.js": [
		9809,
		135
	],
	"./sgrq.js": [
		4236,
		158
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8043;
module.exports = webpackAsyncContext;